import { DateTime } from 'luxon';

export const formatOpeningTimes = (times) => {
    return times.map((group) => {
        const multi = group.days.length > 1;
        const startDay = group.days[0];
        const endDay = multi ? ` - ${group.days[group.days.length - 1]}` : '';
        return `${startDay}${endDay}: ${group.times}`;
    });
};

export const visibleExceptions = (exceptions = []) => {
    console.log('______');
    return exceptions.filter((exception) => {
        console.log(exceptions);
        // Output upcoming exceptions in the next 2 months. Check if index of this/next month, ie. feb -> '-02', is in the holiday date range.
        const currentMonth = `-${DateTime.now().toFormat('MM')}`;
        const nextMonth = `-${DateTime.now().plus({ months: 1 }).toFormat('MM')}`;
        const ranges = `${exception.startDate} ${exception.endDate}`; // '24-12 28-12'
        return ranges.includes(currentMonth) || ranges.includes(nextMonth);
    });
};
